import React from 'react';
import * as Linking from 'expo-linking';
import { OrganizationTypes } from '../../../../primary-record-types';
import Link from '../../../v2BaseComponents/Link';
import { useOrganizationClientRecordInvitationFile } from '../../../../hooks/api/useOrganizationClientRecordInvitationFile';
import Stack from '../../../v2BaseComponents/Stack';

const ClientRecordFile: React.FC<{
    file: OrganizationTypes.OrganizationClientRecordInvitationFileInput;
    organizationClientRecordId: string;
}> = ({ file, organizationClientRecordId }) => {
    const { isLoadingClientRecordInvitationFile, onLoadClientRecordInvitationFile } =
        useOrganizationClientRecordInvitationFile({
            onLoadClientRecordInvitationFileSuccess: (response) => {
                Linking.openURL(response.downloadUrl);
            },
        });

    return (
        <Link
            variant="body-1"
            onPress={() => onLoadClientRecordInvitationFile({ organizationClientRecordId, fileId: file.fileId })}
            testID={`invitation-input-file-${file.name}`}
            linkColor={isLoadingClientRecordInvitationFile ? 'visited' : 'blue'}
            isDisabled={isLoadingClientRecordInvitationFile}
        >
            {file.name}
        </Link>
    );
};

export type InvitationInputFilesOwnProps = {
    files: OrganizationTypes.OrganizationClientRecordInvitationFileInput[];
    organizationClientRecordId: string;
};

export type InvitationInputFilesProps = InvitationInputFilesOwnProps;

const InvitationInputFiles: React.FC<InvitationInputFilesProps> = (props) => {
    return (
        <Stack vertical fullWidth space={2} style={{ paddingLeft: 8 }}>
            {props.files.map((input, index) => (
                <ClientRecordFile
                    key={index}
                    file={input}
                    organizationClientRecordId={props.organizationClientRecordId}
                />
            ))}
        </Stack>
    );
};

export default React.memo(InvitationInputFiles);
